import React from 'react'
import { useLocation } from 'react-router-dom'
import TemplateForm from './TemplateForm'

/**
 * The Edit Template page (`/edit-template?template_id=...`): the template
 * form filled from that template. The library also passes `template_name`,
 * which the form reads from the template itself instead.
 */
const EditTemplate = () => {
    const templateId = new URLSearchParams(useLocation().search).get(
        'template_id'
    )
    return <TemplateForm templateId={templateId ?? ''} />
}

export default EditTemplate
